<template>
  <div class="search-main">
    <Header/>
    <div class="main-1200-width padding-bottom-40 search_box">
      <div class="search_left">
        <div class="cate_box">
          <div class="cate_item1" v-for="(item1,index1) in cateList" :key="index1" :class="cateData.indexOf(item1.id) !== -1 ? 'active' : ''">
            <div class="cate_link1">
              <a href="Javascript:;" @click="searchData(item1.id)" :title="item1.name">{{ item1.name }}</a>
            </div>
            <div class="cate_item2" v-for="(item2,index2) in item1.children" :key="index2" :class="cateData.indexOf(item2.id) !== -1 ? 'active' : ''">
              <div class="cate_link2">
                <a :class="item2.id === cateActive? 'active' : ''" href="Javascript:;" @click="searchData(item2.id)" :title="item2.name">{{ item2.name }}</a>
              </div>
              <div class="cate_item3" v-for="(item3,index3) in item2.children" :key="index3" :class="cateData.indexOf(item3.id) !== -1 ? 'active' : ''">
                <div class="cate_link3">
                  <a :class="item3.id === cateActive? 'active' : ''" href="Javascript:;" @click="searchData(item3.id)" :title="item3.name">{{ item3.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search_right">
        <div class="search-options" v-if="searchList.length > 0">
          <div
            class="search-option"
            v-for="(item, index) in searchList"
            :key="index"
            :data-type="item.open"
          >

            <div class="search-option-title">{{ item["title"] }}</div>
            <div class="search-option-main">
              <div
                class="search-option-item"
                v-for="(temp, num) in item['data']"
                :key="num"
                :class="temp['checked'] ? 'activeSearchItem' : ''"
                @click="clickSearchItem(temp, item, [index, num])"
              >
                {{ temp["value"] }}
              </div>
            </div>
            <div class="search-option-more" @click="open(index,searchList[index]['open'])"></div>
          </div>
        </div>
        <div class="selectedBox" v-if="selectedArr.length > 0">
          <div
            class="item"
            v-for="(item, index) in selectedArr"
            :key="index"
            @click="deleteSelectItem(item)"
          >
            {{ item["name"] }}
            <span style="margin-left: 6px;font-weight: bold;" class="el-icon el-icon-close"></span>
          </div>
        </div>
        <div class="search-order-box">
          <div class="search-order">
            <div
              class="search-order-item "
              data-type="num"
              :class="active == 2 ? 'active' : ''"
              @click="switchActive(2)"
            >
              销量
            </div>
            <div
              class="search-order-item"
              :class="active == 1 ? 'active' : ''"
              data-type="new"
              @click="switchActive(1)"
            >
              新品
            </div>
          </div>
          <div class="search-total">
            <div>共{{ total }}个商品</div>
          </div>
        </div>
        <div class="search-list" v-if="goodsList.length > 0">
          <a
            v-for="(item, index) in goodsList"
            :key="index"
            :href="'/GoodsDetail?id=' + item['id']"
            class="search-list-item"
          >
            <img :src="$url.cdn(item['image'])" alt=""/>
            <p class="list-item-title">{{ item["title"] }}</p>
            <p class="list-item-price" v-if="is_login">￥{{ Array.isArray(item["price"]) ? item["price"][0] : item["price"] }}</p>
            <p class="list-item-price" v-else>价格：**** <a href="/login">登录后查看</a></p>
          </a>
        </div>
        <el-pagination
          v-if="goodsList.length > 0"
          background
          layout="prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pageChange"
          class="page"
        >
        </el-pagination>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import Header from "@/globalComponents/Header";
  import Footer from "@/globalComponents/Footer";
  import categoryApi from "@/api/category.js";
  import goodsApi from "@/api/goods.js"
  export default {
    data() {
      return {
        active     : 2,
        cateActive : 0,
        searchList : [],
        selectedArr: [],
        goodsList  : [],
        total      : 0,
        page       : 1,
        limit      : 20,
        cateList   : [],
        cateData   : []
      };
    },
    computed: {
      ...mapGetters(['is_login']),
    },
    created() {
      if (parseInt(this.$route.params.cate_id) > 0) {
        this.cateActive = parseInt(this.$route.params.cate_id);
      } else {
        this.cateActive = parseInt(this.$route.query.cate_id);
      }
      this.getSearchList(); //step1：获取列表筛选项
      this.getCateTree();   //step4：分类树
      this.getGoodsList();  //step2：商品列表
    },
    methods   : {
      open(index) {
        if (this.searchList[index].open) {
          this.searchList[index].open = '';
        } else {
          this.searchList[index].open = 'open';
        }
        // console.log(index);
        // console.log(this.searchList[index].open);
      },
      //点击分类
      searchData(id) {
        this.cateActive = id;
        this.getCateTree();
        this.getGoodsList();
        this.getSearchList();
      },
      //分类树
      async getCateTree() {
        this.$https.get("/api/mall.category/getCateMenu", {params: {cate_id: this.cateActive}}).then(res => {
          this.cateData = res.data ? res.data : [0];
        });


        let {data} = await categoryApi.list()
        this.cateList = data.children || []
      },
      //获取列表筛选项
      getSearchList() {
        this.$https.get("/api/mall.goods.goods/getListScreen", {params: {cate_id: this.cateActive}}).then(res => {
          let data = res.data;
          let id = this.cateActive;
          let flag = false;
          for (let i in data) {
            if (data[i]["name"] == "category_id") {
              flag = true;
            } else {
              flag = false;
            }
            for (let j in data[i]["data"]) {
              data[i]["data"][j]["checked"] = false;
              if (flag) {
                if (data[i]["data"][j]["id"] == id) {
                  data[i]["data"][j]["checked"] = true;
                  this.selectedArr.push({
                    indexs: [i, j],
                    name  : data[i]["data"][j]["value"],
                    id    : data[i]["data"][j]["id"],
                    item  : data[i]
                  });
                  this.getGoodsList();
                }
              }
            }
          }
          // E== 判断url中是否存在ID
          this.searchList = data;
        });
      },
      //获取商品内容
      async getGoodsList() {
        let data = {
          page  : this.page,
          list_rows : this.limit,
          sort  : this.active == 2 ? 'sales' : 'create_time'
        };
        if (this.cateActive) {
          data['category_id'] = this.cateActive;
        }
        for (let i in this.selectedArr) {
          let item = this.selectedArr[i];
          if (data[item["item"]["name"]]) {
            data[item["item"]["name"]] = data[item["item"]["name"]] + "," + item["id"];
          } else {
            data[item["item"]["name"]] = item["id"];
          }
        }

        let {data: goodsData} = await goodsApi.list(data)
        this.goodsList = goodsData.data;
        this.total = goodsData.total;
      },
      clickSearchItem(temp, item, indexs) {
        temp["checked"] = temp["checked"] ? false : true;
        if (temp["checked"]) {
          if (item["name"] == "price") {
            // 重置选中样式
            for (let i in this.searchList) {
              if (this.searchList[i]["name"] == "price") {
                let iItem = this.searchList[i]["data"];
                for (let j in iItem) {
                  iItem[j]["checked"] = false;
                }
              }
              temp["checked"] = true;
            }
            // 删除目前所有选中的金额
            for (let i in this.selectedArr) {
              if (this.selectedArr[i]["item"]["name"] == "price") {
                this.selectedArr.splice(i, 1);
              }
            }
            // 重新push
            this.selectedArr.push({
              indexs,
              name: temp["value"],
              id  : temp["id"],
              item
            });
          } else {
            this.selectedArr.push({
              indexs,
              name: temp["value"],
              id  : temp["id"],
              item
            });
          }
        } else {
          for (let i in this.selectedArr) {
            if (this.selectedArr[i]["id"] == temp["id"]) {
              this.selectedArr.splice(i, 1);
            }
          }
        }
        this.getGoodsList();
      },
      pageChange(e) {
        this.page = e;
        this.getGoodsList();
      },
      switchActive(e) {
        this.active = e;
        this.getGoodsList();
      },
      //删除对应筛选项
      deleteSelectItem(item) {
        for (let i in this.selectedArr) {
          if (this.selectedArr[i]["id"] == item["id"]) {
            this.selectedArr.splice(i, 1);
          }
        }
        this.searchList[item["indexs"][0]]["data"][item["indexs"][1]][
          "checked"
          ] = false;
        this.getGoodsList();
      }
    },
    components: {
      Header,
      Footer
    }
  };
</script>
<style lang="less" scoped>
  @import url("./list.less");
</style>



// WEBPACK FOOTER //
// src/components/screen/list.vue